/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationClientLegalEntityVerificationRequestStatusResource
 */
export interface OrganizationClientLegalEntityVerificationRequestStatusResource {
    /**
     * 
     * @type {string}
     * @memberof OrganizationClientLegalEntityVerificationRequestStatusResource
     */
    legalEntityId: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationClientLegalEntityVerificationRequestStatusResource
     */
    legalName?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationClientLegalEntityVerificationRequestStatusResource
     */
    registrationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationClientLegalEntityVerificationRequestStatusResource
     */
    formattedAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationClientLegalEntityVerificationRequestStatusResource
     */
    countryCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationClientLegalEntityVerificationRequestStatusResource
     */
    mandatoryLegalInformationComplete: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationClientLegalEntityVerificationRequestStatusResource
     */
    hasPendingVerificationRequest: boolean;
}

/**
 * Check if a given object implements the OrganizationClientLegalEntityVerificationRequestStatusResource interface.
 */
export function instanceOfOrganizationClientLegalEntityVerificationRequestStatusResource(value: object): value is OrganizationClientLegalEntityVerificationRequestStatusResource {
    if (!('legalEntityId' in value) || value['legalEntityId'] === undefined) return false;
    if (!('mandatoryLegalInformationComplete' in value) || value['mandatoryLegalInformationComplete'] === undefined) return false;
    if (!('hasPendingVerificationRequest' in value) || value['hasPendingVerificationRequest'] === undefined) return false;
    return true;
}

export function OrganizationClientLegalEntityVerificationRequestStatusResourceFromJSON(json: any): OrganizationClientLegalEntityVerificationRequestStatusResource {
    return OrganizationClientLegalEntityVerificationRequestStatusResourceFromJSONTyped(json, false);
}

export function OrganizationClientLegalEntityVerificationRequestStatusResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationClientLegalEntityVerificationRequestStatusResource {
    if (json == null) {
        return json;
    }
    return {
        
        'legalEntityId': json['legalEntityId'],
        'legalName': json['legalName'] == null ? undefined : json['legalName'],
        'registrationNumber': json['registrationNumber'] == null ? undefined : json['registrationNumber'],
        'formattedAddress': json['formattedAddress'] == null ? undefined : json['formattedAddress'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'mandatoryLegalInformationComplete': json['mandatoryLegalInformationComplete'],
        'hasPendingVerificationRequest': json['hasPendingVerificationRequest'],
    };
}

export function OrganizationClientLegalEntityVerificationRequestStatusResourceToJSON(value?: OrganizationClientLegalEntityVerificationRequestStatusResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'legalEntityId': value['legalEntityId'],
        'legalName': value['legalName'],
        'registrationNumber': value['registrationNumber'],
        'formattedAddress': value['formattedAddress'],
        'countryCode': value['countryCode'],
        'mandatoryLegalInformationComplete': value['mandatoryLegalInformationComplete'],
        'hasPendingVerificationRequest': value['hasPendingVerificationRequest'],
    };
}

